import Order from '../models/Order';
import Helpers from '../base/Helpers';
import PaymentTransaction from './PaymentTransaction';

export default class AuthTokenization extends PaymentTransaction {
	/**
	 * Associate and mapping Order model properties to transaction
	 *
	 * @param order
	 */
	setOrder(order: Order) {
		this.order_id = order.id;
		this.order_currency = order.currency;
		this.order_amount = Helpers.parseAmount(order.amount);
	}
}
